import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'
import { Queue } from '@nicolaudie-group/ls-utilities'

const profileQueue = new Queue({
  autoStart: true,
  concurrentCount: 1,
  autoClear: true,
  throwOnError: true,
})

dev.expose({ profileQueue })

export default profileQueue
